import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Leaf } from "lucide-react";

const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, ease: "easeOut", delay: (index % 4) * 0.06 }}
    >
      <Link
        to={`/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group flex flex-col h-full bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-[0_18px_50px_-24px_rgba(10,17,40,0.28)] hover:border-gray-300 transition-all duration-300"
      >
        <div
          className="relative aspect-square overflow-hidden border-b"
          style={{ backgroundColor: `${product.accent}12`, borderColor: `${product.accent}33` }}
        >
          {product.photo ? (
            <img
              src={product.photo}
              alt={`${product.name} supplement`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            />
          ) : (
            <div
              className="bottle-crop w-full h-full transition-transform duration-500 group-hover:scale-[1.04]"
              style={{ backgroundImage: `url(${product.image})`, backgroundPosition: product.bgPos }}
              role="img"
              aria-label={`${product.name} supplement`}
            />
          )}
          <span
            className="absolute top-3 left-3 text-[0.65rem] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full bg-white/90 border border-gray-200"
            style={{ color: product.accent }}
          >
            {product.collection === "life-stage" ? "Life-Stage" : "Everyday"}
          </span>
          {product.vegan && (
            <span
              data-testid={`vegan-badge-card-${product.slug}`}
              className="absolute top-3 right-3 inline-flex items-center gap-1 text-[0.6rem] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full bg-emerald-50/95 border border-emerald-200 text-emerald-700"
            >
              <Leaf size={10} /> Vegan
            </span>
          )}
        </div>
        <div className="flex flex-col flex-1 p-5">
          <h3 className="font-display text-xl font-medium text-ink">{product.name}</h3>
          <p className="text-sm text-gray-500 mt-1 flex-1">{product.concern}</p>
          <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
            <span className="text-xs text-gray-400 font-medium">{product.serving}</span>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink group-hover:text-rose transition-colors duration-200">
              View <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-200" />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
